import axios from 'axios';
import { getCookie, removeCookie } from './cookie';
import appConfig from '../config';
import { message } from 'antd';
import { NotificationManager } from 'react-notifications';

const api = axios.create({
  baseURL: `${appConfig.API_OAUTH2_URL}`,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
});

api.interceptors.request.use(
  function (config) {
    let accessToken = getCookie('token');

    const clientTimezone = new Date().getTimezoneOffset(); // Đổi sang múi giờ tính theo giờ UTC
    // Thêm thông tin múi giờ vào tiêu đề 'Timezone'
    config.headers['Timezone'] = `${clientTimezone > 0 ? '' : '+'}${Math.floor(
      clientTimezone / -60
    )
      .toString()
      .padStart(2, '0')}:${(Math.abs(clientTimezone) % 60)
      .toString()
      .padStart(2, '0')}`;

    // Do something before request is sent
    if (accessToken) {
      config.headers.common['Authorization'] = 'Bearer ' + accessToken;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // console.log("error", error);
    if (error && error.response && error.response.status === 401) {
      removeCookie('token');
      let message = 'Phiên đã hết hạn. Vui lòng đăng nhập lại!';
      if (error.response.data.message) {
        message = error.response.data.message;
      }

      if (
        window.location.pathname != '/login' &&
        window.location.pathname != '/reset-password' &&
        window.location.pathname('signup')
      ) {
        // setTimeout(() => {
        //     window.location.reload();
        // }, 1000);
        NotificationManager.error(message);
        window.location.href = '/login';
      }
    }
    if (error && error.response && error.response.status === 500) {
      message.error('Internal server error');
    }

    return Promise.reject(error.response);
  }
);

export default api;
